<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h1 class="headline font-weight-light mb-3">
          <router-link class="link-a" :to="'/Inventory/Issue'">
            View DocumentReturnDefective</router-link
          >
          / PRINT
        </h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn rounded small @click="print()">
          <v-icon class="mr-1" dark small>mdi-printer</v-icon>
          Print</v-btn
        >
      </v-col>
    </v-row>
    <div id="printDiv">
      <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
      <div align="center" class="style2">
        <br />
        <br /><!-- 
        <div align="right">
            <span style="font-size: 15px;font-weight:bold;">เลขที่เอกสาร DOC20060355</span>
            <input type="hidden" id="no_doc" name="no_doc" value="DOC20060355">
            <input type="hidden" id="id_no_doc" name="id_no_doc" value="1">
        </div>
        <br> -->
        <div>
          <div>
            <label style="margin-left:175px;font-size: 35px;font-weight:bold;"
              ><u>MOTHERBOARD RETURN TAG</u></label
            >
            <img
              style="margin-left:80px;"
              src="../Itservice/hp.png"
              height="150"
              width="150"
            />
          </div>
          <div align="left" style="margin-left:10px;vertical:text-top;">
            <label style="font-size: 22px;font-weight:bold;"
              ><u>A.Parts Return Information</u></label
            >
          </div>
          <div style="width:95%;vertical:text-top;">
            <v-row>
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;height:65px;"
                >Service Provider</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >HP Case ID</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >Repair Date</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >Product Unit PN</v-col
              >
            </v-row>
            <v-row style="margin-top:5px;">
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;height:65px;"
                >Product Unit SN</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >Spare Part No.</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >Part RMA#</v-col
              >
              <v-col
                col="3"
                style="text-align:left;border:2px solid black;margin-left:5px;"
                >Part CT</v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="margin-top:20px;margin-left:10px;vertical:text-top;"
          >
            <label style="font-size: 22px;font-weight:bold;"
              ><u>B.Parts Fault Information</u></label
            >
          </div>
          <div
            align="left"
            style="width:100%;margin-top:20px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col
                col="4"
                style="text-align:left;height:65px;font-weight:500;"
                >1.Part Type</v-col
              >
              <v-col col="4" style="text-align:left;">
                <label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;">DOA Part</label></v-col
              >
              <v-col col="4" style="text-align:left;"
                ><label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;">Used Part</label></v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col
                col="4"
                style="text-align:left;height:65px;font-weight:500;"
                >2.Fault Category</v-col
              >
              <v-col col="4" style="text-align:left;">
                <label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;">Functional Fault</label></v-col
              >
              <v-col col="4" style="text-align:left;"
                ><label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;">Physical Damage</label></v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col col="4" style="text-align:left;height:65px;"></v-col>
              <v-col col="4" style="text-align:left;">
                <label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;"
                  >Wrong Parts In Box</label
                ></v-col
              >
              <v-col col="4" style="text-align:left;"
                ><label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;"
                  >Upgrade According to Advisory</label
                ></v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col md="4" style="text-align:left;height:65px;font-weight:500;"
                >3.Fault Type</v-col
              >
              <v-col md="2.2" style="text-align:left;">
                <label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;">Sustained Fault</label></v-col
              >
              <v-col md="5" style="text-align:left;margin-left:-50px;">
                <label style="margin-left:-50px;"
                  >Time to Fault___Min___Hrs___Day</label
                ></v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col md="4" style="text-align:left;height:65px;"></v-col>
              <v-col md="2.2" style="text-align:left;">
                <label style="font-weight:bold;font-size: 18px;">[</label
                ><label
                  style="margin-left:20px;font-weight:bold;font-size: 18px;"
                  >]</label
                ><label style="margin-left:5px;"
                  >InterMittebt Fault</label
                ></v-col
              >
              <v-col md="5" style="text-align:left;margin-left:-50px;">
                <label style="margin-left:-50px;"
                  >Time to Fault___Min___Hrs___Day</label
                ></v-col
              >
            </v-row>
          </div>
          <div
            align="left"
            style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
          >
            <v-row style="margin-top:5px;">
              <v-col md="4" style="text-align:left;height:65px;font-weight:500;"
                >4.Fault Description</v-col
              >
              <v-col md="2" style="text-align:left;"> </v-col>
              <v-col md="6" style="text-align:left;"> </v-col>
            </v-row>
          </div>
          <div style="font-size:12px;">
            <div
              align="left"
              style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB01</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Not Power On</label></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB10</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Memory error</label></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB02</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >No Boot (Power On but No Display)</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB11</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Hard drive error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:-3px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:53px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Continuously Blinking battery power LED</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:21px;">MB12</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >DVD or CD error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:-3px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:53px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Continuously Blinking power adapter LED</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:21px;">MB13</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Battery charging error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:-3px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:53px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Times of Caps Lock/Num Lock blinking____(fill in
                    1-6)</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:21px;">MB14</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Keyboard/Trackpoint error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:-3px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:53px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Others_______________</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:21px;">MB15</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Tounch pad error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB03</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Power On Password Lock</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB16</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Touch screen Fault</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB04</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Auto Boot/Reboot/Auto Shutdown</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB17</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Camera error</label></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB05</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >System Hangs up</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB18</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >LAN/Modem error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB06</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Can not Shut Down/Sleep/Hibernate</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB19</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Wireless error (WLAN, WWAN and Blue Tooth)</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB07</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Can not Rusume from Sleep or Hibernate</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB20</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Fan Problem</label></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB08</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >BlueScreen (Error Code)___________________</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB21</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Overheating Issue</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB09</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >OS Running Slowly/Performance Issue</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;">MB22</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Audio input/output error</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="12" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB23</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Setup error (such as BIOS/driver setting)</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="2.2" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB24</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Display issue</label></v-col
                >
                <v-col
                  md="3"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Black screen</label></v-col
                >
                <v-col
                  md="1.2"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Blinking screen</label
                  ></v-col
                >
                <v-col
                  md="3.6"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >External display</label
                  ></v-col
                >
                <v-col md="2" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:-40px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Others__________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="2.2" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB25</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">I/O Port Issue</label></v-col
                >
                <v-col
                  md="3"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Card reader/Express Card</label
                  ></v-col
                >
                <v-col
                  md="1.2"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Docking</label></v-col
                >
                <v-col
                  md="3.6"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">USB/eSATA/1394</label></v-col
                >
                <v-col md="2" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:-40px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Others__________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="2.2" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB26</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Bad Cosmetic</label></v-col
                >
                <v-col
                  md="3"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Component lost/crack</label
                  ></v-col
                >
                <v-col
                  md="1.2"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Rusty</label></v-col
                >
                <v-col
                  md="3.6"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Corroslon/Mildew/Dusty</label
                  ></v-col
                >
                <v-col md="2" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:-40px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Solder joint issue</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="2.2" style="text-align:left;height:65px;"></v-col>
                <v-col
                  md="3"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Label discrepancy</label
                  ></v-col
                >
                <v-col
                  md="1.2"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Connector broken</label
                  ></v-col
                >
                <v-col
                  md="3.6"
                  style="text-align:left;height:65px;margin-left:-65px;"
                >
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >PCB broken or scratch</label
                  ></v-col
                >
                <v-col md="2" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:-40px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Others__________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <br />
            <div
              align="left"
              style="width:100%;margin-top:-60px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="12" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB27</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Upgrade According to Advisory (fill in EA/SA
                    No.)_________________________________________________________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="12" style="text-align:left;height:65px;"
                  ><label style="font-weight:400;margin-left:10px;">MB28</label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;"
                    >Other
                    (describe)________________________________________________________________________________________________________________________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <br />
            <div
              align="left"
              style="width:100%;margin-top:-60px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col
                  md="12"
                  style="text-align:left;height:65px;font-weight:500;font-size:16px;"
                  >5.Steps of duplicating the fault (to be filled out by the
                  Repair Technician)</v-col
                >
                <v-col md="2" style="text-align:left;"></v-col>
                <v-col md="6" style="text-align:left;"> </v-col>
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-40px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:20px;">
                <v-col md="12" style="text-align:left;height:65px;">
                  <label style="margin-left:5px;"
                    >_______________________________________________________________________________________________________________________________________________________________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-50px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col
                  md="12"
                  style="text-align:left;height:65px;font-weight:500;font-size:16px;"
                  >Were multiple parts replaced during this repair?</v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-30px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:0px;">
                <v-col
                  md="7"
                  style="text-align:left;height:65px;font-weight:500;font-size:16px;"
                  >If yes, please descibe the other parts replaced.</v-col
                >
                <v-col
                  md="2.5"
                  style="text-align:left;height:65px;font-weight:500;font-size:16px;"
                  ><label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">Yes</label></v-col
                >
                <v-col
                  md="2.5"
                  style="text-align:left;height:65px;font-weight:500;font-size:16px;"
                  ><label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label style="margin-left:5px;">No</label></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;margin-top:-35px;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:10px;">
                <v-col md="12" style="text-align:left;height:65px;">
                  <label style="margin-left:5px;"
                    >_______________________________________________________________________________________________________________________________________________________________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="margin-top:-35px;margin-left:10px;vertical:text-top;"
            >
              <label style="font-size: 22px;font-weight:bold;"
                ><u>C.Troubleshooting Performed</u></label
              >
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;"
            >
              <v-row style="margin-top:-10px;">
                <v-col md="4" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Check Power Supply</label
                  ></v-col
                >
                <v-col md="4" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Reseat Key Componets</label
                  ></v-col
                >
                <v-col md="4" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Check Inner Cable</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-40px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="4" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Load BIOS Default Setting</label
                  ></v-col
                >
                <v-col md="8" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Upgrade BIOS Version To (please fill
                    in)_________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-40px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="4" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Clean Connector</label
                  ></v-col
                >
                <v-col md="4" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >CMOS Battery Discharge</label
                  ></v-col
                >
                <v-col md="4" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Reinstall Driver</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-40px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="4" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Recover Factory OS</label
                  ></v-col
                >
                <v-col md="8" style="text-align:left;"
                  ><label style="font-weight:400;margin-left:10px;"></label>
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Check display output by an external monitor</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-40px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="12" style="text-align:left;height:65px;">
                  <label
                    style="font-weight:bold;font-size: 18px;margin-left:10px;"
                    >[</label
                  ><label
                    style="margin-left:20px;font-weight:bold;font-size: 18px;"
                    >]</label
                  ><label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Duplicate the fault by minimum installantion</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-40px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="12" style="text-align:left;height:65px;">
                  <label
                    style="margin-left:5px;font-size:15px;font-weight:bold;"
                    >Other Actions
                    _____________________________________________________________________________________________________________________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-10px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;">
                  <label
                    style="margin-left:70px;font-size:15px;font-weight:bold;"
                  >
                    ___________________________________________</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;height:65px;">
                  <label
                    style="margin-left:110px;font-size:15px;font-weight:bold;"
                  >
                    ___________________________________________</label
                  ></v-col
                >
              </v-row>
            </div>
            <div
              align="left"
              style="width:100%;vertical:text-top;margin-left:10px;margin-top:-50px;"
            >
              <v-row style="margin-top:5px;">
                <v-col md="6" style="text-align:left;height:65px;">
                  <label
                    style="margin-left:120px;font-size:15px;font-weight:bold;"
                  >
                    Signature of Engineer</label
                  ></v-col
                >
                <v-col md="6" style="text-align:left;height:65px;">
                  <label
                    style="margin-left:140px;font-size:15px;font-weight:bold;"
                  >
                    Signature of Cheif Engineer</label
                  ></v-col
                >
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

export default {
  mounted() {},
  ...mapMutations(["mutateMiniSidebar"]),
  methods: {
    print() {
      this.$htmlToPaper("printDiv");
    },
  },
  data() {
    return {
      data_print: [],
    };
  },
};
</script>
<style scoped>
body {
  margin: 0 !important;
}

td {
  border: 2px solid black;
  height: 50px;
  vertical-align: top;
  padding-left: 2px;
}
</style>
